import { Component, Input } from '@angular/core';

@Component({
  selector: 'cm-ad-unit-bdr-badge',
  template: `
    <div class="cm-badge" aria-hidden="true" *ngIf="bidder && bidderDp" [matTooltip]="bidderDp" [ngClass]="{'bg-success': serverbid}">B</div>
    <div class="cm-badge" aria-hidden="true" *ngIf="bidder && !bidderDp" matTooltip="Bidder">B</div>
  `,
})
export class AdUnitBdrBadgeComponent {

  @Input()
  bidder: boolean;

  @Input()
  serverbid: boolean;

  @Input()
  bidderDp: string;
}
